import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-neutral-dark text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src="https://static.readdy.ai/image/66a2b9cfb9b417b2846085a20d5b8a97/39f48c36d78167ba77a6bec1ef6513fc.png"
                alt="RightChain"
                className="h-10 w-10 object-contain"
              />
              <span className="text-2xl font-bold">RightChain</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              {t('footer_desc')}
            </p>
            <div className="flex gap-4">
              <a href="https://x.com/RightChain2026" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors cursor-pointer">
                <i className="ri-github-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors cursor-pointer">
                <i className="ri-telegram-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors cursor-pointer">
                <i className="ri-discord-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer_services')}</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footer_service_1')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footer_service_2')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footer_service_3')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footer_service_4')}</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer_legal')}</h4>
            <ul className="space-y-3">
              <li><Link to="/legal" className="text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footer_legal_1')}</Link></li>
              <li><Link to="/legal" className="text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footer_legal_2')}</Link></li>
              <li><Link to="/legal" className="text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footer_legal_3')}</Link></li>
              <li><Link to="/legal" className="text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footer_legal_4')}</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer_contact')}</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">
                <i className="ri-mail-line mr-2"></i>
                service@nftservice.io
              </li>
              <li className="text-gray-400">
                <i className="ri-customer-service-line mr-2"></i>
                {t('footer_contact_service')}
              </li>
              <li className="text-gray-400">
                <i className="ri-file-text-line mr-2"></i>
                {t('footer_contact_docs')}
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            {t('footer_copyright')}
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
